import Api from "./api";

export const setMarketingData = async (cartId, utmParams) => {
  const data = await Api.post(
    `/checkout/cart/${cartId}/marketingData`,
    utmParams
  );

  return data;
};

export const getFreightData = async (cep) => {
  const data = await Api.get(`/freight/cep/${cep}`);

  return data;
};
